/**
 * Returns the input string omitting the last character if it's a slash.
 */
export default function stripTrailingSlash(value: string): string {
  return value[value.length - 1] === "/" ? value.slice(0, -1) : value;
}
